import React from 'react';
import logger from '../utils/logger';

/**
 * Catches render errors in child components and shows a fallback UI
 * instead of crashing the entire application.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('react', 'Render error caught by ErrorBoundary', {
      error: error.message,
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'var(--bg-base, #0B0C12)',
          color: 'var(--text-primary, #E8E6F0)',
          fontFamily: 'var(--font-ui, sans-serif)',
          gap: '16px',
          padding: '40px',
          textAlign: 'center',
        }}>
          <h2 style={{ fontSize: '20px', fontWeight: 500 }}>Something went wrong</h2>
          <p style={{ fontSize: '14px', color: 'var(--text-muted, #6E6D80)', maxWidth: '400px' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '8px',
              padding: '8px 20px',
              borderRadius: 'var(--radius, 8px)',
              border: '1px solid var(--border, #2D2E3D)',
              background: 'var(--bg-card, #1A1B26)',
              color: 'var(--text-primary, #E8E6F0)',
              cursor: 'pointer',
              fontSize: '13px',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
